export default __webpack_public_path__ + "static/media/markerObject.1fe454ba.svg";